$(function () {
	scroll();
});
function scroll() {

	$('.simple-text .jump-to a').on('click', function (e) {
		e.preventDefault();
		var target = $(this).attr('href');
		$('html,body').animate({
			scrollTop: $(target).offset().top - 200
		}, 500);
	});
}